import { StylesConfig } from "react-select/src/styles";
import omit from "lodash/omit";

import { colors } from "../../../theme";

const styles: StylesConfig = {
  control: provided => ({
    ...provided,
    backgroundColor: "unset",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
  }),
  dropdownIndicator: (provided, { selectProps: { menuIsOpen } }) => ({
    ...omit(provided, ":hover"),
    color: colors["wild-blue"],
    transition: 'all .2s ease',
    transform: `rotate(${ menuIsOpen ? 180 : 0 }deg)`,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    color: isSelected ? "#fff" : colors["wild-blue"],
    textAlign: "end",
  }),
  placeholder: provided => ({
    ...provided,
    color: colors["wild-blue"],
    fontSize: "16px",
  }),
  singleValue: provided => ({
    ...provided,
    color: colors["wild-blue"],
    fontSize: "16px",
    fontWeight: "bold",
  }),
  valueContainer: provided => ({
    ...provided,
    justifyContent: "flex-end",
  }),
};

export default styles;
